import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { updateBlogs, addBlogs, getBlogsBySlug } from "../../api/blogs";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const AddWorkArray = useRef();
  const toaster = useToaster();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();

  const getWorkQuery = useQuery({
    queryKey: ["works", id],
    queryFn: getBlogsBySlug,
    enabled: !!id,
  });

  const getBlogBySlugQuery = useQuery({
    queryKey: ["blogs", id],
    queryFn: getBlogsBySlug,
    enabled: id ? true : false,
  });

  const updateWorkQuery = useMutation({ mutationFn: updateBlogs });
  const addWorkItemQuery = useMutation({ mutationFn: addBlogs });

  const initialValues = useMemo(() => {
    const workAddData = getWorkQuery?.data?.data || {};
    return {
      works: {
        meta_title: workAddData?.meta_title || "",
        slug_url: workAddData?.slug_url || "",
        meta_description: workAddData?.meta_description || "",
        meta_keywords: workAddData?.meta_keywords || "",

        title: workAddData?.title || "",
        is_publish: workAddData?.is_publish || false,
        keywords: workAddData?.keywords?.join(", ") || "",
        description: workAddData?.description || "",
        banner_img: workAddData?.banner_img || "",
      },
    };
  }, [getWorkQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      meta_title: values?.works?.meta_title || "",
      slug_url: values?.works?.slug_url || "",
      meta_keywords: values?.works?.meta_keywords || "",
      meta_description: values?.works?.meta_description || "",

      title: values?.works?.title || "",
      is_publish: values?.works?.is_publish,
      description: values?.works?.description || "",
      keywords: values?.works?.keywords
        ? values.works?.keywords.split(",").map((k) => k.trim())
        : [],
      banner_img: values.works.banner_img,
    };

    if (id) {
      payload.id = getBlogBySlugQuery?.data?.data?._id;
      updateWorkQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success(
            Const.MESSAGES.SUCCESS,
            Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
          );
        },
      });
      return;
    }
    addWorkItemQuery.mutate(payload, {
      onSuccess: () => {
        navigate(-1);
        toaster.success(
          Const.MESSAGES.SUCCESS,
          Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
        );
      },
    });
  };

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getWorkQuery,
        handleSubmit,
      }}>
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
